<template>
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="trading_record_box">
      <div class="left">
        <leftTemplate :left_tabShow="'trading_record'"></leftTemplate>
      </div>
      <div class="right">
        <!-- 素材交易 -->
        <div class="statistics">
          <div>
            <div style="display: flex">
              <div class="statistics_des">余额</div>

              <el-tooltip
                content="Bottom center"
                placement="right"
                effect="customized"
              >
                <div class="quan">?</div>
                <template #content>
                  <div class="quan_text">
                    素材交易余额:{{
                      userObj.materialIn
                        ? (userObj.materialIn / 1).toFixed(2)
                        : 0
                    }}元
                  </div>
                  <!-- <br /> -->
                  <div class="quan_text">
                    业务交易余额
                    {{ userObj.needIn ? (userObj.needIn / 1).toFixed(2) : 0 }}元
                  </div>
                </template>
              </el-tooltip>
            </div>
            <div class="statistics_content">
              {{ userObj.amount ? (userObj.amount / 1).toFixed(2) : 0 }}
              <span style="font-size: 0.14rem">元</span>
            </div>
          </div>
          <div>
            <div class="statistics_des">用户退款</div>
            <div class="statistics_content">
              {{
                userObj.materialOut
                  ? (
                      (userObj.needOut / 1).toFixed(2) +
                      (userObj.materialOut / 1).toFixed(2)
                    ).toFixed(2)
                  : userObj.materialOut
                  ? (
                      (userObj.needOut / 1).toFixed(2) +
                      (userObj.materialOut / 1).toFixed(2)
                    ).toFixed(2)
                  : 0
              }}<span style="font-size: 0.14rem">元</span>
            </div>
          </div>
          <div>
            <div class="statistics_des">累计总收入</div>
            <div class="statistics_content">
              <span style="color: #c01a26">
                {{ userObj.in ? (userObj.in / 1).toFixed(2) : 0 }}</span
              ><span style="font-size: 0.14rem">元</span>
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            border-top: 1px solid #e5e6eb;
            border-bottom: 1px solid #e5e6eb;
            padding-top: 0.2rem;
          "
        >
          <div
            class="top_tab"
            @click="leftGoto('/tradingRecord')"
            :class="top_tabShow == 'trading' ? 'top_tab_select' : ''"
          >
            素材交易
          </div>
          <div class="top_tab" @click="leftGoto('/tradingRequirement')">
            业务交易
          </div>
        </div>
        <el-table
          ref="multipleTableRef"
          :data="tableData"
          style="width: 100%"
          height="338"
        >
          <el-table-column property="name" min-width="100" label="素材名称">
            <template #default="scope">
              <div style="display: flex">
                <div style="" class="table_img">
                  <img
                    style="
                      border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
                      width: 0.6rem;
                      height: 0.6rem;
                    "
                    :src="scope.row.showImage"
                  />
                </div>
                <div class="table_information">
                  <div
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      color: #333333;
                      font-size: 0.14rem;
                    "
                  >
                    {{ scope.row.title }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="订单号"
            align="center"
            property="orderNo"
            width="190"
          />
          <el-table-column label="价格" align="center" property="sellerAmount">
            <template #default="scope">
              <div><span>￥</span>{{ (scope.row.price / 1).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="销售分成" align="center" property="price">
            <template #default="scope">
              <div><span>￥</span>{{ (scope.row.sellerAmount / 1).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="售出时间" align="center" property="payTime" />

          <!-- <el-table-column label="成交搜索词" align="center" property="type" /> -->

          <el-table-column
            label="状态"
            width="100"
            align="center"
            property="type"
          >
            <template #default="scope">
              <div
                style="background: #4bc18520; color: #4bc185"
                v-if="scope.row.status == 1"
              >
                交易成功
              </div>
              <div
                style="background: #f53f3f20; color: #f53f3f"
                v-if="scope.row.status == 3"
              >
                交易失败
              </div>
              <div
                style="background: #66666620; color: #666"
                v-if="scope.row.status == 2"
              >
                交易取消
              </div>
              <div
                style="background: #c01a2620; color: #c01a26"
                v-if="scope.row.status == 0"
              >
                交易待支付
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="display: flex; justify-content: center">
          <el-pagination
            v-if="tableData.length != 0"
            v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="margin: 0.4rem 0"
            background
            layout="prev, pager, next"
            :total="page.total"
          />
        </div>
        <!-- 需求服务 -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
document.title = "标识山西-我的收益";
const top_tabShow = ref("trading");

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};
// 表格

interface User {}

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
var data = []; // 创建一个空数组

const tableData = ref([]);
let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
const page = pageDef;
let form = ref({});
const init = () => {
  Axios(
    "get",
    "/fodder/order/seller-list",
    {
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
      orderByColumn: "createTime",
      isAsc: "desc",
    },
    false,
    function (res) {
      tableData.value = res.data.rows;
      page.value.total = res.data.total;
      form.value.totol = res.data.rows.reduce(
        (total, order) => total + order.price,
        0
      );
      let params = {
        payModel: "MATERIAL",
      };
      Axios(
        "get",
        "/member/account-manage/account",
        params,
        false,
        function (res: any) {
          console.log(res.data);

          form.value.IN = res.data.data.in;
          form.value.OUT = res.data.data.out;
        }
      );
      params = {
        payModel: "OUT",
      };
      Axios(
        "get",
        "/member/account-manage/account",
        params,
        false,
        function (res: any) {
          form.value.data = res.data.data;
        }
      );
      // page.value.total = res.data.total;
    }
  );
};
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
init();
import { useRouter } from "vue-router";
const router = useRouter();
// 提现金额
const userObj = ref({});
const getInfo = () => {
  Axios("get", "/member/account-manage/info", false, false, (res) => {
    // myBankList.value = res.data.data;
    // console.log(res.data);
    userObj.value = res.data.data;
  });
};
getInfo();
//直接跳转
const leftGoto = (type) => {
  console.log("dianji ", type);
  router.push(type);
};
</script>

<style lang="less">
@import url(/src/assets/css/left_right.css);

.trading_record_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
}

.top_title {
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
  color: #86909c;
}

.top_tab {
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #333333;
  margin-left: 0.4rem;
  cursor: pointer;
}

.top_tab_select {
  color: #c01a26;
}

.table_img {
  background-color: #3fa4ed;
  width: 0.6rem;
  height: 0.6rem;
  background: #d9d9d9;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  margin-right: 0.1rem;
}

.table_information {
  width: calc(100% - 0.6rem - 0.1rem);
  height: 0.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.top_tab_select {
  color: #c01a26;
}

// 统计
.statistics {
  display: flex;
  justify-content: space-around;
  padding: 0.2rem 0;
}

.statistics_des {
  font-size: 0.14rem;
}

.statistics_content {
  font-size: 0.24rem;
  margin-top: 0.04rem;
}
/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}
.quan {
  width: 0.2rem;
  height: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-left: 3px;
  text-align: center;
  line-height: 0.2rem;
}
.quan_text {
  padding: 5px 0;
  font-size: 15px;
}

.el-popper.is-customized {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: #c01a26;
  color: #fff;
}

.el-popper.is-customized .el-popper__arrow::before {
  background: #c01a26;
  color: #fff;
  right: 0;
}
</style>
